<template>
  <div class="page_header">
    <div class="header_logo">
      <img src="/static/image/logo.png" alt="">
    </div>
    <div class="header_title clearfix">
      <div class="header_search"></div>
      <div class="header_login"></div>
      <a class="left" href="http://www.shanghaiba.org/index.php/Home/Aboutcomittee/index.html" target="_blank">关于协会</a>
      <a class="left" href="http://www.shanghaiba.org/index.php/Home/Matchnews/index.html" target="_blank">新闻动态</a>
      <a class="left" href="http://www.shanghaiba.org/index.php/Home/Matchstars/index.html" target="_blank">人物纵横</a>
      <a class="left" href="http://www.shanghaiba.org/index.php/Home/Matchapply/index.html" target="_blank">赛事通道</a>
      <a class="left" href="http://www.shanghaiba.org/index.php/Home/Medialogin/index.html" target="_blank">媒体中心</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-header'
}
</script>



// WEBPACK FOOTER //
// src/containers/page-header.vue